import PostsAdapter from './base';

export default class Comment extends PostsAdapter {
  modelNamePlural = 'comments';
}
